export function matchesAgencyFilter(
  agencyName: string | null | undefined,
  agencies: string[],
): boolean {
  if (agencies.length === 0) return true;
  if (!agencyName) return false;

  const normalizedName = agencyName.toLowerCase();
  return agencies.some((agency) => {
    const normalizedAgency = agency.toLowerCase();
    return (
      normalizedAgency === normalizedName ||
      normalizedName.includes(normalizedAgency)
    );
  });
}
